var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "section-head" }, [_vm._v("抽奖规则配置")]),
    _c(
      "div",
      { staticClass: "rule-block" },
      [
        _c(
          "div",
          {
            staticClass: "status-tip",
            staticStyle: { "margin-bottom": "8px" },
          },
          [_vm._v("满足条件触发")]
        ),
        _c(
          "div",
          { staticClass: "rule-row" },
          [
            _c(
              "el-checkbox",
              {
                staticStyle: {
                  width: "108px",
                  "text-align": "right",
                  "margin-bottom": "18px",
                },
                model: {
                  value: _vm.ruleFlags.login,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleFlags, "login", $$v)
                  },
                  expression: "ruleFlags.login",
                },
              },
              [_vm._v("每日登录赠送")]
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "ruleValues.daily_login_bonus_count",
                  "label-width": "0",
                },
              },
              [
                _c("el-input-number", {
                  staticClass: "rule-input-num",
                  attrs: {
                    min: 0,
                    precision: 0,
                    controls: false,
                    disabled: !_vm.ruleFlags.login,
                  },
                  model: {
                    value: _vm.ruleValues.daily_login_bonus_count,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleValues, "daily_login_bonus_count", $$v)
                    },
                    expression: "ruleValues.daily_login_bonus_count",
                  },
                }),
              ],
              1
            ),
            _c("span", { staticClass: "rule-suffix" }, [_vm._v("次")]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "rule-row" },
          [
            _c(
              "el-checkbox",
              {
                staticStyle: {
                  width: "108px",
                  "text-align": "right",
                  "margin-bottom": "18px",
                },
                model: {
                  value: _vm.ruleFlags.bet,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleFlags, "bet", $$v)
                  },
                  expression: "ruleFlags.bet",
                },
              },
              [_vm._v("今日投注达到")]
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "ruleValues.daily_bet_amount",
                  "label-width": "0",
                },
              },
              [
                _c("el-input-number", {
                  staticClass: "rule-input-num",
                  attrs: {
                    min: 0,
                    precision: 2,
                    controls: false,
                    disabled: !_vm.ruleFlags.bet,
                  },
                  model: {
                    value: _vm.ruleValues.daily_bet_amount,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleValues, "daily_bet_amount", $$v)
                    },
                    expression: "ruleValues.daily_bet_amount",
                  },
                }),
              ],
              1
            ),
            _c("span", { staticClass: "rule-suffix" }, [_vm._v("赠送")]),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "ruleValues.daily_bet_amount_ticket_reward",
                  "label-width": "0",
                },
              },
              [
                _c("el-input-number", {
                  staticClass: "rule-input-num",
                  attrs: {
                    min: 0,
                    precision: 0,
                    controls: false,
                    disabled: !_vm.ruleFlags.bet,
                  },
                  model: {
                    value: _vm.ruleValues.daily_bet_amount_ticket_reward,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.ruleValues,
                        "daily_bet_amount_ticket_reward",
                        $$v
                      )
                    },
                    expression: "ruleValues.daily_bet_amount_ticket_reward",
                  },
                }),
              ],
              1
            ),
            _c("span", { staticClass: "rule-suffix" }, [_vm._v("次")]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "rule-row" },
          [
            _c(
              "el-checkbox",
              {
                staticStyle: {
                  width: "108px",
                  "text-align": "right",
                  "margin-bottom": "18px",
                },
                model: {
                  value: _vm.ruleFlags.payin,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleFlags, "payin", $$v)
                  },
                  expression: "ruleFlags.payin",
                },
              },
              [_vm._v("今日存款达到")]
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "ruleValues.daily_total_payin_amount",
                  "label-width": "0",
                },
              },
              [
                _c("el-input-number", {
                  staticClass: "rule-input-num",
                  attrs: {
                    min: 0,
                    precision: 2,
                    controls: false,
                    disabled: !_vm.ruleFlags.payin,
                  },
                  model: {
                    value: _vm.ruleValues.daily_total_payin_amount,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleValues, "daily_total_payin_amount", $$v)
                    },
                    expression: "ruleValues.daily_total_payin_amount",
                  },
                }),
              ],
              1
            ),
            _c("span", { staticClass: "rule-suffix" }, [_vm._v("赠送")]),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "ruleValues.daily_total_payin_amount_ticket_reward",
                  "label-width": "0",
                },
              },
              [
                _c("el-input-number", {
                  staticClass: "rule-input-num",
                  attrs: {
                    min: 0,
                    precision: 0,
                    controls: false,
                    disabled: !_vm.ruleFlags.payin,
                  },
                  model: {
                    value:
                      _vm.ruleValues.daily_total_payin_amount_ticket_reward,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.ruleValues,
                        "daily_total_payin_amount_ticket_reward",
                        $$v
                      )
                    },
                    expression:
                      "ruleValues.daily_total_payin_amount_ticket_reward",
                  },
                }),
              ],
              1
            ),
            _c("span", { staticClass: "rule-suffix" }, [_vm._v("次")]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "rule-row" },
          [
            _c(
              "el-checkbox",
              {
                staticStyle: {
                  width: "108px",
                  "text-align": "right",
                  "margin-bottom": "18px",
                },
                model: {
                  value: _vm.ruleFlags.level,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleFlags, "level", $$v)
                  },
                  expression: "ruleFlags.level",
                },
              },
              [_vm._v("VIP升级赠送")]
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "ruleValues.level_up_bonus_count",
                  "label-width": "0",
                },
              },
              [
                _c("el-input-number", {
                  staticClass: "rule-input-num",
                  attrs: {
                    min: 0,
                    precision: 0,
                    controls: false,
                    disabled: !_vm.ruleFlags.level,
                  },
                  model: {
                    value: _vm.ruleValues.level_up_bonus_count,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleValues, "level_up_bonus_count", $$v)
                    },
                    expression: "ruleValues.level_up_bonus_count",
                  },
                }),
              ],
              1
            ),
            _c("span", { staticClass: "rule-suffix" }, [_vm._v("次")]),
          ],
          1
        ),
        _c("el-form-item", {
          staticStyle: { display: "none" },
          attrs: { prop: "spinRuleAtLeastOne" },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }